import type {InnStepValues, PersonalInfoStepValues} from 'features/registration';

export const EMPTY_PERSONAL_INFO: PersonalInfoStepValues = {
	citizenshipOksmCode: null,
	citizenshipCountryName: null,
	residenceOksmCode: null,
	residenceCountryName: null,
	gender: 'male',
	secondName: '',
	firstName: '',
	patronymic: '',
	email: '',
};

export const EMPTY_INN: InnStepValues = {
	inn: '',
};
